// extracted by mini-css-extract-plugin
export default {"header":"HeaderWithLogo_header__pImQn","leftLogo":"HeaderWithLogo_leftLogo__4I+yg"};